export enum DICCIONARIO {
  FECHA_NACIMIENTO = 'Fecha de nacimiento',
  PRIMER_NOMBRE = 'Primer nombre',
  SEGUNDO_NOMBRE = 'Segundo nombre',
  TERCER_NOMBRE = 'Tercer nombre',
  PRIMER_APELLIDO = 'Primer apellido',
  SEGUNDO_APELLIDO = 'Segundo apellido',
  APELLIDO_CASADA = 'Apellido de casada',
  NIT = 'NIT',
  NUMERO_IDENTIFICACION = 'Número de identificación',
  USERNAME = 'Nombre de usuario',
  PASSWORD = 'Contraseña',
  CONFIRM_PASSWORD = 'Confirmar contraseña',
  CODIGO_EMPRESA = 'Código de empresa',
  EMAIL = 'Correo electrónico',
  TELEFONO = 'Teléfono celular',
  DIRECCION = 'Dirección',
  CODIGO_VERIFICACION = 'Código de verificación',
  TIPO_DOCUMENTO_IDENTIFICACION = 'Tipo de documento de identificación',
  NUMERO_DOCUMENTO_IDENTIFICACION = 'Número de documento de identificación',
  TIPO_DTE = 'Tipo de documento',
}
